// extracted by mini-css-extract-plugin
export default {"div":"MyOrderDetail_div__6nao0"};